import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  TOGGLE_OPEN_CHARACTER_DETAILS_TABLE,
  SET_CHARACTER_DETAILS_TABLE_BOSS_RANKINGS,
  SET_CHARACTER_BOSS_KILL_DETAILS
} from '../actions/characterActionCreator';
import { TAction } from '../actions/types/action';

const initialState = {
  bossKills: {},
  loadingBossKills: {},
  loadedBossKills: {},
  openSections: {},
  loadedSections: {},
  loadingSections: {}
};

export default function characterRaidRankingReducer(state: any = initialState, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case TOGGLE_OPEN_CHARACTER_DETAILS_TABLE: {
      const newState: any = {
        openSections: {},
        loadedSections: {},
        loadingSections: {},
        ...state
      };
      const key = `${action.payload.raid}-${action.payload.difficulty}`;
      newState.openSections[key] = newState.openSections[key] !== undefined ? !newState.openSections[key] : true;
      return newState;
    }
    case SET_CHARACTER_DETAILS_TABLE_BOSS_RANKINGS: {
      const key = `${action.payload.raid}-${action.payload.difficulty}`;
      const newState: any = {
        ...state
      };
      newState.loadedSections[key] = action.payload.bossRankings;
      return newState;
    }
    case SET_CHARACTER_BOSS_KILL_DETAILS: {
      const key = `${action.payload.raid}-${action.payload.boss}-${action.payload.difficulty}`;
      const newState: any = {
        bossKills: {},
        loadingBossKills: {},
        loadedBossKills: {},
        ...state
      };
      newState.bossKills[key] = action.payload.details;
      newState.loadedBossKills[key] = true;
      return newState;
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
